module.exports = __webpack_public_path__ + "static/media/ca.b71457da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ca.svg
// module id = 79
// module chunks = 0